module.exports = __webpack_public_path__ + "img/logonew.f17258eb.png";